<template>
  <div class="login-form">
    <h3>Dein Benutzername</h3>
    <!-- <input class="login-form__input" v-model="name" />
    <button class="login-form__button" @click="setUserByName(name)">Weiter</button>-->
    <VueTelegramLogin
      mode="callback"
      telegram-login="teechnikbot"
      @callback="doLogin"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { vueTelegramLogin } from "vue-telegram-login";

export default {
  components: { VueTelegramLogin: vueTelegramLogin },
  data() {
    return {
      name: ""
    };
  },
  methods: {
    ...mapActions(["login"]),

    doLogin(payload) {
      this.login(payload);
    }
  }
};
</script>

<style>
.login-form__input,
.login-form__button {
  font-size: inherit;
  background-color: #eeffee;
  line-height: inherit;
  letter-spacing: inherit;
  font-family: inherit;
  border: 0;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s 0.5s;
  margin-right: 0.2em;
}
.login-form__button:hover {
  background-color: #99ff99;
}
.login-form__input {
  background-color: #eee;
}
.login-form__input:focus,
.login-form__input:hover {
  background-color: #fff;
}
</style>
